import { useEffect } from "react";
import moment from "moment";

import { defaultAnswerType } from "../constants/answerType";

const useSavedValuesFromSessionsStorage = (
	setFieldsValue,
	getFieldDecorator
) => {
	useEffect(() => {
		if (sessionStorage.getItem("new-voting")) {
			const setValues = {};
			const savedFormValues = JSON.parse(sessionStorage.getItem("new-voting"));
			setValues.title = savedFormValues.title;
			setValues.description = savedFormValues.description;
			if (savedFormValues.period) {
				setValues.period = savedFormValues.period.map((date) => moment(date));
			}
			if (savedFormValues.questionsKeys) {
				getFieldDecorator(`questionsKeys`, {
					initialValue: "0",
				});
				setValues.questionsKeys = savedFormValues.questionsKeys;
			}
			if (savedFormValues.addresses) {
				savedFormValues.addresses.forEach((value, index) => {
					if (value !== null) {
						getFieldDecorator(`addresses[${index}]`, {
							initialValue: false,
						});
						setValues[`addresses[${index}]`] = value;
					}
				});
			}
			if (savedFormValues.questions) {
				savedFormValues.questions
					.filter(Boolean)
					.forEach((question, questionIndex) => {
						getFieldDecorator(`questions[${questionIndex}].title`, {
							initialValue: "",
						});
						setValues[`questions[${questionIndex}].title`] = question.title;
						getFieldDecorator(`questions[${questionIndex}].answerKeys`, {
							initialValue: "0",
						});
						setValues[`questions[${questionIndex}].answerKeys`] =
							question.answerKeys;
						getFieldDecorator(`questions[${questionIndex}].answerType`, {
							initialValue: defaultAnswerType,
						});
						setValues[`questions[${questionIndex}].answerType`] =
							question.answerType;
						getFieldDecorator(`questions[${questionIndex}].obligatory`, {
							initialValue: false,
							valuePropName: "checked",
						});
						setValues[`questions[${questionIndex}].obligatory`] =
							question.obligatory;
						getFieldDecorator(`questions[${questionIndex}].haveOtherOption`, {
							initialValue: false,
						});
						setValues[`questions[${questionIndex}].haveOtherOption`] =
							question.haveOtherOption;
						if (question.answers) {
							question.answers
								.filter(Boolean)
								.forEach((answer, answerIndex) => {
									getFieldDecorator(
										`questions[${questionIndex}].answers[${answerIndex}].text`,
										{
											initialValue: false,
										}
									);
									setValues[
										`questions[${questionIndex}].answers[${answerIndex}].text`
									] = answer.text;
								});
						}
					});
			}
			setFieldsValue(setValues);
		}
	}, []);
};

export default useSavedValuesFromSessionsStorage;
